<app-stages-order-preview [stages]="stages$ | async" [loading]="loading$ | async"></app-stages-order-preview>